__turbopack_context__.v({
  "body": "Accordion-module-scss-module__NkU5_a__body",
  "bodyCentered": "Accordion-module-scss-module__NkU5_a__bodyCentered",
  "container": "Accordion-module-scss-module__NkU5_a__container",
  "header": "Accordion-module-scss-module__NkU5_a__header",
  "headerIndicator": "Accordion-module-scss-module__NkU5_a__headerIndicator",
  "open": "Accordion-module-scss-module__NkU5_a__open",
});
